import React from 'react';
import Helmet from 'react-helmet';
import { Grid, Row, Col } from 'react-flexbox-grid';

import AppFixedHeader from '../../containers/AppFixedHeader';
import Divider from '../Divider';
import Donate from '../Donate';
import SocialLinks from '../../containers/SocialLinks';
import SupportContact from '../SupportContact';

import './DonatePage.css';
import get from 'lodash-es/get';
import Content from '../Content';

const DonatePage = ({ companyInfo, donateContent }) => (
  <div className="DonatePage py-4 py-lg-5">
    <Helmet title="Donate" />

    <AppFixedHeader />

    <Grid fluid>
      <Row>
        <Col xs={6}>
            <h1 className="title mb-4">{donateContent.title}</h1>
        </Col>
        <Col xs={6} className="text-right">
          <SocialLinks className="ml-lg-5 mb-4" />
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <Divider className="mb-5 mt-2" />
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={8}>
          <Content content={get(donateContent, 'body', 'No content.')} />
        </Col>
        <Col xs={12} md={4} className="hidden visible-md">
          <SupportContact />
        </Col>
      </Row>

      <Row className="mt-4">
        <Col xs={12}>
          <Donate />
        </Col>
      </Row>
    </Grid>
  </div>
);

export default DonatePage;
